import React from "react";
import { graphql, StaticQuery } from "gatsby";
import PublicationsList from "./PublicationsList";
const FeaturedPublications = () => {
  return (
    <StaticQuery
      query={graphql`
        query {
          allMarkdownRemark(
            filter: {
              frontmatter: { templateKey: { eq: "selected-publications" } }
            }
          ) {
            edges {
              node {
                id
                frontmatter {
                  publications {
                    title
                    authors
                    journal
                    link
                  }
                }
              }
            }
          }
        }
      `}
      render={data => {
        const {
          publications
        } = data.allMarkdownRemark.edges[0].node.frontmatter;

        return <PublicationsList publications={publications} />;
      }}
    />
  );
};

export default FeaturedPublications;
